import React, { useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import ModuleAccessGuard from './ModuleAccessGuard';

const Layout = () => {
  useEffect(() => {
    document.body.classList.add('layout-fixed');

    return () => {
      document.body.classList.remove('layout-fixed');
    };
  }, []);

  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <ModuleAccessGuard>
          <Outlet />
        </ModuleAccessGuard>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
